<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  computed: {
    pageTitle() {
      return this.$store.getters["basic/pageTitle"];
    },
  },
};
</script>

<style lang="scss"></style>
